import { makeAutoObservable } from 'mobx'
import type { IResponseCnam } from 'entities/Compliance/api/types/cnamType'

export class Cnam {
  private _id: IResponseCnam['id'] | null = null
  private _name: IResponseCnam['name'] | null = null
  private _count: IResponseCnam['numbers_count'] | null = null
  private _status: IResponseCnam['status'] | null = null
  private _registrationErrors: IResponseCnam['registration_errors'] | null = null
  private _origin: IResponseCnam

  constructor(response: IResponseCnam) {
    makeAutoObservable(this)

    this._origin = response

    this.syncData(response)
  }

  syncData = (response: IResponseCnam) => {
    this._id = response.id
    this._name = response.name
    this._count = response.numbers_count
    this._status = response.status
    this._registrationErrors = response.registration_errors
    this._origin = response
  }

  get origin() {
    return this._origin
  }

  get id() {
    return this._id || 0
  }

  get name() {
    return this._name || ''
  }

  get count() {
    return this._count
  }

  get status() {
    return this._status
  }

  get isStatusPending() {
    return this._status === 'pending'
  }

  get registrationError() {
    if (!this._registrationErrors) return null

    return this._registrationErrors[0]
  }

  get showActions() {
    return !this.isStatusPending
  }

  get canDelete() {
    return this._status === 'approved' || this._status === 'failed'
  }

  get canEdit() {
    return this._status === 'approved'
  }
}
